import { Validator } from 'fluentvalidation-ts';
import { SqlServer } from '../Model/SqlServerModel';
import Validation from './SqlServerValidationConstants.json';

export class SqlServerValidator extends Validator<SqlServer> {
  constructor() {
    super();
    this.ruleFor('ServerName')
      .notEmpty()
      .withMessage(Validation.serverName.notEmpty)
      .notNull()
      .withMessage(Validation.serverName.notEmpty)
      .matches(/^[a-z0-9-]+$/)
      .withMessage(Validation.serverName.matches)
      .maxLength(63)
      .withMessage(Validation.serverName.maxLength)
      .must(this.noStartOrEndHyphen)
      .withMessage(Validation.serverName.startEndHyphen)
      .must(this.noDoubleHyphen)
      .withMessage(Validation.serverName.doubleHyphen);

    this.ruleFor('ResourceGroup')
      .notEmpty()
      .withMessage(Validation.resourceGroup.notEmpty)
      .notNull()
      .withMessage(Validation.resourceGroup.notEmpty);

    this.ruleFor('UserName')
      .notEmpty()
      .withMessage(Validation.userName.notEmpty)
      .notNull()
      .withMessage(Validation.userName.notEmpty)
      .minLength(3)
      .withMessage(Validation.userName.minLength)
      .maxLength(128)
      .withMessage(Validation.userName.maxLength)
      .matches(/^[a-zA-Z0-9._]+$/)
      .withMessage(Validation.userName.matches);

    this.ruleFor('AdminPassword')
      .notEmpty()
      .withMessage(Validation.adminPassword.notEmpty)
      .notNull()
      .withMessage(Validation.adminPassword.notEmpty)
      .minLength(8)
      .withMessage(Validation.adminPassword.minLength)
      .must((password) => /[A-Z]/.test(password))
      .withMessage(Validation.adminPassword.upperCase)
      .must((password) => /[a-z]/.test(password))
      .withMessage(Validation.adminPassword.lowerCase)
      .must((password) => /[0-9]/.test(password))
      .withMessage(Validation.adminPassword.numeric);

    this.ruleFor('Subscription')
      .notEmpty()
      .withMessage(Validation.subscription.notEmpty)
      .notNull()
      .withMessage(Validation.subscription.notEmpty);

    this.ruleFor('ProductID')
      .notEmpty()
      .withMessage(Validation.productID.notEmpty)
      .notNull()
      .withMessage(Validation.productID.notEmpty);

    this.ruleFor('Role')
      .notEmpty()
      .withMessage(Validation.role.notEmpty)
      .notNull()
      .withMessage(Validation.role.notEmpty);

    this.ruleFor('Region')
      .notEmpty()
      .withMessage(Validation.region.notEmpty)
      .notNull()
      .withMessage(Validation.region.notEmpty);
  }

  private noStartOrEndHyphen = (serverName: string) => {
    return !serverName.startsWith('-') && !serverName.endsWith('-');
  };

  private noDoubleHyphen = (serverName: string) => {
    return !(
      serverName.length > 3 &&
      serverName[2] === '-' &&
      serverName[3] === '-'
    );
  };
}
